import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-5.5,0.5h1.5v0.5h-1.5zM-2,1h1.5v0.5h-1.5zM3,1h0.5v0.5h-0.5z' },
    {
      paint: 'rock',
      d: 'M-1,-13h2v0.5h-2zM-1.5,-12.5h3.5v1.5h-3.5zM-1.5,-11h3v0.5h-3zM-1.5,-10.5h2.5v0.5h-2.5zM1,-10h0.5v0.5h-0.5zM-3,-8.5h1v0.5h-1zM-3,-8h2v0.5h-2zM-3,-7.5h2.5v0.5h-2.5zM-3.5,-7h3.5v1.5h-3.5zM-4,-5.5h4v1h-4zM-4,-4.5h3.5v0.5h-3.5zM-4.5,-4h4.5v0.5h-4.5zM-4.5,-3.5h5v0.5h-5zM-5,-3h5.5v1h-5.5zM-5.5,-2h6v0.5h-6zM-6,-1.5h2v0.5h-2zM-3.5,-1.5h4.5v0.5h-4.5zM-6,-1h1.5v0.5h-1.5zM-3,-1h4v0.5h-4zM-6.5,-0.5h7.5v1h-7.5zM-4,0.5h5.5v0.5h-5.5zM-0.5,1h2v0.5h-2z',
    },
    {
      paint: 'boulder',
      d: 'M1.5,-9h0.5v0.5h-0.5zM1,-8.5h1v0.5h-1zM0.5,-8h2v0.5h-2zM1,-7.5h1.5v0.5h-1.5zM1,-7h2v0.5h-2zM1.5,-6.5h1.5v0.5h-1.5zM1,-6h2.5v1h-2.5zM1,-5h3v1h-3zM1,-4h3.5v0.5h-3.5zM1.5,-3.5h3v0.5h-3zM1.5,-3h3.5v0.5h-3.5zM0.5,-2.5h0.5v0.5h-0.5zM2,-2.5h3v0.5h-3zM0.5,-2h5v0.5h-5zM-4,-1.5h0.5v0.5h-0.5zM1,-1.5h4.5v0.5h-4.5zM-4.5,-1h1.5v0.5h-1.5zM1,-1h5v1h-5zM1,0h5.5v0.5h-5.5zM1.5,0.5h4.5v0.5h-4.5zM1.5,1h1.5v0.5h-1.5z',
    },
    {
      paint: 'trunk',
      d: 'M-2,-10h3v0.5h-3zM-2.5,-9.5h1v0.5h-1zM0.5,-9.5h1v0.5h-1zM-2.5,-9h0.5v0.5h-0.5zM1,-9h0.5v0.5h-0.5zM-2,-8.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'campfireFlame',
      d: 'M-1.5,-9.5h2v0.5h-2zM-2,-9h0.5v0.5h-0.5zM0.5,-9h0.5v0.5h-0.5zM-1.5,-8.5h0.5v0.5h-0.5zM0,-8.5h1v0.5h-1zM-1,-8h0.5v0.5h-0.5zM0,-8h0.5v0.5h-0.5zM-0.5,-7.5h1.5v0.5h-1.5zM0,-7h1v0.5h-1zM0.5,-6.5h1v0.5h-1zM0,-6h1v1.5h-1zM-0.5,-4.5h1.5v0.5h-1.5zM0,-4h1v0.5h-1zM0.5,-3.5h1v1h-1zM1,-2.5h1v0.5h-1z',
    },
    {
      paint: 'torchFlame',
      d: 'M-1.5,-9h2v0.5h-2zM-1,-8.5h1v0.5h-1zM-0.5,-8h0.5v0.5h-0.5zM0,-6.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 409,
};
export const sprites: readonly PixelSprite[] = [variant0];
